import React, {useState} from 'react'
import {Layer, Stage, Text} from "react-konva";
import Konva from "konva";
import KonvaEventObject = Konva.KonvaEventObject;

const DraggableText = () => {
    const [displayTextDetail, setDisplayTextDetail] = useState({
        isDragging: false,
        x: 50,
        y: 50
    });

    const afterDragStarted = () => {
        setDisplayTextDetail({...displayTextDetail, ['isDragging']: true});
    }

    const afterDragEnded = (event) => {
        const x = event.target.x();
        const y = event.target.y();

        console.log('x:', x);
        console.log('y:', y);

        const currentDisplayTextDetail = {...displayTextDetail};
        currentDisplayTextDetail.x = x;
        currentDisplayTextDetail.y = y;
        currentDisplayTextDetail.isDragging = false;
        setDisplayTextDetail(currentDisplayTextDetail);
    }

    const handleCursor = (event: KonvaEventObject<MouseEvent>) => {
        const stage = event.target.getStage();
        if (stage) {
            if (event.type === "mouseenter") {
                stage.container().style.cursor = "pointer";
            } else {
                stage.container().style.cursor = "default";
            }
        }
    };

    return (
        <>

            <Stage width={window.innerWidth * 3 / 4} height={window.innerHeight * 3 / 4}
                   className="">
                <Layer className="border border-blue-600">
                    <Text
                        text="Draggable Text"
                        x={displayTextDetail.x}
                        y={displayTextDetail.y}
                        fontSize={30}
                        draggable
                        fill={displayTextDetail.isDragging ? 'green' : 'black'}
                        onDragStart={afterDragStarted}
                        onDragEnd={afterDragEnded}
                        onMouseEnter={handleCursor}
                        onMouseLeave={handleCursor}
                    />
                </Layer>
            </Stage>

        </>
    )
}

export default DraggableText
